import React from 'react';
import Financial from '../images/finance.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Tax Strategy Development',
    description: 'Develop tax strategies to optimize tax liabilities and ensure compliance with tax laws.',
  },
  {
    icon: <FaLock />,
    title: 'Tax Preparation & Filing',
    description: 'Manage tax preparation and filing to meet deadlines and avoid penalties.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Tax Advisory Services',
    description: 'Provide expert advice on tax matters to make informed decisions and maximize tax benefits.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Audit Support',
    description: 'Offer support during tax audits to ensure smooth and compliant processes.',
  }
];


const TaxPlanning = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Financial}
        alt="Financial Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Tax Planning & Compliance</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Finance Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored Finance Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Finance planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
      </div>
      </section>

    </div>

    </div>
  )
}

export default TaxPlanning
